import { render } from "./CustomCommand.vue?vue&type=template&id=f55be7f2"
import script from "./CustomCommand.vue?vue&type=script&lang=js"
export * from "./CustomCommand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__